module.exports = __webpack_public_path__ + "img/20201205_155926.7d94edf5.jpg";